import type { LoadableType } from '@confluence/loadable';
import { LoadableAfterPaint, MustPreloadLoadableNames } from '@confluence/loadable';
import type { QueryProps } from './Renderer.tsx';

const RendererLoader: LoadableType<QueryProps> = LoadableAfterPaint({
	// Name needs to match the one in next/packages/view-page/src/index.ts
	name: MustPreloadLoadableNames.ClassicRendererLoader,
	loader: () => import(/* webpackChunkName: "loadable-RendererQuery" */ './Renderer.tsx'),
});

export default RendererLoader;
